import React, { useEffect, useState } from 'react';
import Constants from "../../../helper/Constants";
import { useObjCommonFilterStore } from "../../../hooks/objCommonFilter";
import { useDOMAttachToSystemStore } from "../../../hooks/domAttachToSystem";

function OrderAdminSearch() {
  const [search, setSearch] = useState({ searchBy: "", searchValue: "" });
  const [{ filter_list }, , { set_filter_list }] = useObjCommonFilterStore();
  let [validation, setValidation] = useState({});
  const [{ }, { system_alert_indicator, remove_system_alert_indicator }, { }] = useDOMAttachToSystemStore();
  const { AdminOrderOptions, AdminOrderState } = Constants

  const onSearch = (event) => {
    event.preventDefault();
    const valid = validate();
    if (valid) {
      remove_system_alert_indicator("AdminOrderError");
      const searchObj = {
        [search.searchBy]: {
          searchType: AdminOrderOptions[search.searchBy],
          key: search.searchBy,
          searchKeyword: search.searchValue,
        }
      };
      if (Object.entries(searchObj)?.[0]?.[0] && Object.entries(searchObj)?.[0]?.[1]?.searchKeyword) {
        set_filter_list(searchObj);
      }
    } else {
      system_alert_indicator({
        name: 'AdminOrderError',
        message: validation.searchBy || validation.searchValue,
        type: "danger",
        isDisplay: false,
        isDisplayIcon: true
      })
    }
  }
  const validate = () => {
    validation = {
      searchBy: search.searchBy ? null : "Please select a 'Search By' option",
      searchValue: (search.searchValue && search.searchValue.length >= 2) ? null : "Please enter at least 2 characters to execute a keyword search."
    }
    setValidation(validation);
    const validationArr = Object.entries(validation).filter(([key, value]) => {
      return !!value;
    })
    return validationArr?.length === 0;
  }

  useEffect(() => {
    setSearch({
      searchBy: Object.entries(filter_list)[0]?.[0] || "",
      searchValue: Object.entries(filter_list)[0]?.[1].searchKeyword || ""
    });
  }, [filter_list]);

  return (<>
    <div className='acsearchuser'>
      <div className='bg-grey2'>
        <div className='container'>
          <div className="accordion-item ">
            <h2 className="accordion-header" id="searchInput">
              <button className="accordion-button" type="button" data-toggle="collapse"
                      data-target="#collapseSearch" aria-expanded="true" aria-controls="collapseOne">
                <b className="font-16">Search</b>
              </button>
            </h2>
            <div id="collapseSearch" className="accordion-collapse collapse in"
                 aria-labelledby="searchInput"
                 data-parent="#accordionExample">
              <div className="accordion-body p-0">
                <form>
                  <div className='orderadmin-search'>
                    <div className='orderadmin-search-content'>
                      <div className="row bs5">
                        <div className="col-sm-12 col-md-6 mb-2">
                          <label htmlFor="searchBy">Search By</label>
                          <div className='selectbox'>
                            <select
                              id="searchBy"
                              className="form-control form-control-sm"
                              value={search.searchBy}
                              onChange={(event) => {
                                setSearch({
                                  searchBy: event.target.value,
                                  searchValue: event.target.value === "OrderState" ? "PendingAuth" : ""
                                });
                              }}
                            >
                              <option value={""}>--Select--</option>
                              {Object.entries(AdminOrderOptions).map(([key, value]) => (
                                <option key={key} value={key}>{value}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                        {search.searchBy === "OrderState" ?
                          <div className="col-sm-12 col-md-6 mb-2">
                            <label
                              htmlFor={search.searchBy}>{AdminOrderOptions[search.searchBy]}</label>
                            <div className='selectbox'>
                              <select
                                className="form-control form-control-sm"
                                id={search.searchBy}
                                value={search.searchValue}
                                onChange={(event) => {
                                  setSearch({ ...search, searchValue: event.target.value });
                                }}
                              >
                                {Object.entries(AdminOrderState).map(([key, value]) => (
                                  <option key={key} value={key}>{value}</option>
                                ))}
                              </select>
                            </div>
                          </div> :
                          <div className="col-sm-12 col-md-6 mb-2">
                            <label className=''
                                   htmlFor={search.searchBy}>{AdminOrderOptions[search.searchBy]}</label>
                            <input className="ps-2 form-control form-control-sm mb-0"
                                   value={search.searchValue}
                                   id={search.searchBy}
                                   placeholder={AdminOrderOptions[search.searchBy]}
                                   type="text"
                                   onChange={(event) => {
                                     setSearch({ ...search, searchValue: event.target.value });
                                   }}
                            />
                          </div>
                        }

                      </div>
                    </div>
                    <div className=" text-sm-end mt-3 pe-0">
                      <button className="btn btn-secondary bs5 w140" onClick={onSearch}>Search</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>);
}


export default OrderAdminSearch;